function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatabricks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 40.1 42"
    },
    viewBox: "0 0 40.1 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M40.1 31.1v-7.4l-.8-.5-19.2 10.5-18.2-10v-4.3l18.2 9.9 20.1-10.9v-7.3l-.8-.5-19.3 10.6-17.5-9.6L20.1 2l14.1 7.7 1.1-.6v-.8L20.1 0 0 10.9V12l20.1 11 18.2-10v4.4l-18.2 10L.8 16.8l-.8.5v7.4l20.1 10.9 18.2-9.9V30L20.1 40 .8 29.5 0 30v1.1L20.1 42l20-10.9z",
    style: {
      fill: "#ff3621"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabricks);
export default __webpack_public_path__ + "static/media/databricks.784e0796436df25bae306868b4e8f511.svg";
export { ForwardRef as ReactComponent };